








import '@/styles/root.scss'
import Vue from 'vue'
import Component from 'vue-class-component'
import BrowserNotSupported from './views/common/BrowserNotSupported.vue'
import { Debounce } from 'vue-debounce-decorator'
import Api from '@/api'
import { UserModule } from '@/store/modules/user.module'
import { getModule } from 'vuex-module-decorators'
import { ChainModule } from '@/store/modules/chain.module'
import ScrollView from '@/components/ScrollView.vue'
import NotificationBar from '@/components/NotificationBar.vue'

const { detect } = require('detect-browser')
const browser = detect()

@Component({
  components: {
    ScrollView,
    NotificationBar,
    BrowserNotSupported
  }
})
export default class Root extends Vue {
  lastActivity: Date = new Date()
  isBrowserSupported: boolean = true
  userModule: UserModule = getModule(UserModule, this.$store)
  chainModule: ChainModule = getModule(ChainModule, this.$store)
  isScrollDisabled: boolean = false

  goLoginIfNeed () {
    const user = Api.getUser()
    const userData = (user || { data: null }).data
    if (
        (
          window.location.pathname.indexOf('/admin') !== -1 ||
          window.location.pathname.indexOf('/management') !== -1
        ) && (!user || user.isExpired())
    ) {
      Api.logout(false)
      this.$router.push({ name: 'login', query: { nextUrl: window.location.pathname } })
    } else {
      this.userModule.setUser(userData)
    }
    this.chainModule.getChainById((userData || { chain: '' }).chain as string | number)
  }

  async mounted () {
    this.goLoginIfNeed()
    setInterval(this.checkActivity.bind(this), 60 * 1000)

    if (browser && browser.name === 'ie') {
      this.isBrowserSupported = false
    }
    this.$eventBus.$on('Root:disableScroll', () => {
      this.isScrollDisabled = true
    })
    this.$eventBus.$on('Root:enableScroll', () => {
      this.isScrollDisabled = false
    })
    this.$watch('$route', () => {
     this.$eventBus.$emit('loading:disable')
    })

    await Api.utils.getAppVersion()
  }

  beforeDestroy () {
  }

  checkActivity () {
    const user = Api.getUser()
    const userData = (user || { data: null }).data
    if (user) {
      if (Date.now() - this.lastActivity.getTime() < user.expireDefault) {
        Api.updateTokenIfNeed()
      }
    } else {
      this.userModule.setUser(userData)
    }
    this.goLoginIfNeed()
  }

  @Debounce(10 * 1000)
  handleActivity () {
    const user = Api.getUser()
    if (user) {
      this.userModule.setUser((user || { data: null }).data)
      this.lastActivity = new Date()
    }
  }

  emitClick () {
    this.$eventBus.$emit('body:click')
  }
}
